import { Dom } from '../util';
import { Highlighter } from '../registry';
import { Base } from './base';
export class HighlightManager extends Base {
    constructor() {
        super(...arguments);
        this.highlights = {};
    }
    init() {
        this.graph.on('cell:highlight', ({ view, magnet, options }) => this.onCellHighlight(view, magnet, options));
        this.graph.on('cell:unhighlight', ({ view, magnet, options }) => this.onCellUnhighlight(view, magnet, options));
    }
    onCellHighlight(cellView, magnet, options = {}) {
        const resolved = this.resolveHighlighter(options);
        if (!resolved) {
            return;
        }
        const key = this.getHighlighterId(magnet, resolved);
        if (!this.highlights[key]) {
            const highlighter = resolved.highlighter;
            highlighter.highlight(cellView, magnet, Object.assign({}, resolved.args));
            this.highlights[key] = {
                cellView,
                magnet,
                highlighter,
                args: resolved.args,
            };
        }
    }
    onCellUnhighlight(cellView, magnet, options = {}) {
        const resolved = this.resolveHighlighter(options);
        if (!resolved) {
            return;
        }
        const key = this.getHighlighterId(magnet, resolved);
        const highlight = this.highlights[key];
        if (highlight) {
            // Use the cellView and magnetEl that were used by the highlighter.highlight() method.
            highlight.highlighter.unhighlight(highlight.cellView, highlight.magnet, highlight.args);
            delete this.highlights[key];
        }
    }
    resolveHighlighter(options) {
        let highlighterDef = options.highlighter;
        const graphOptions = this.options;
        if (highlighterDef == null) {
            // check for built-in types
            const type = options.type;
            highlighterDef =
                (type && graphOptions.highlighting[type]) ||
                    graphOptions.highlighting.default;
        }
        if (highlighterDef == null) {
            return null;
        }
        const def = typeof highlighterDef === 'string'
            ? {
                name: highlighterDef,
            }
            : highlighterDef;
        const name = def.name;
        const highlighter = Highlighter.registry.get(name);
        if (highlighter == null) {
            return Highlighter.registry.onNotFound(name);
        }
        Highlighter.check(name, highlighter);
        return {
            name,
            highlighter,
            args: def.args || {},
        };
    }
    getHighlighterId(magnet, options) {
        Dom.ensureId(magnet);
        return options.name + magnet.id + JSON.stringify(options.args);
    }
}
//# sourceMappingURL=highlight.js.map